import { Components } from '@mui/material/styles';

const muiTabsStyles: Components = {
  MuiTabs: {
    styleOverrides: {
      root: { maxHeight: '62px' },
      indicator: {
        height: '4px',
        zIndex: 2,
        '@media (max-width: 1715px)': {
          height: '3px'
        }
      }
    }
  },
  MuiTab: {
    styleOverrides: {
      root: {
        fontSize: '16px',
        color: 'var(--blue-4)',
        padding: '0 40px',
        // minHeight: '48px',
        // height: '48px',
        flexDirection: 'row',
        fontWeight: '600',
        gap: '8px',
        alignItems: 'center',
        '&.MuiTab-labelIcon': {
          minHeight: 50
        },
        '&.Mui-selected': {
          fontWeight: '600'
        },
        '& .MuiTab-iconWrapper': {
          marginBottom: 0
        },
        '@media (max-width: 1715px)': {
          fontSize: '13px',
          padding: '0 34px'
        }
      }
    }
  }
};

export const segmentedTabsSx = {
  minHeight: 'unset',
  width: '100%',
  maxWidth: '100%',
  overflow: 'visible',
  '& .MuiTabs-scroller': { overflow: 'visible !important' },
  '& .MuiTabs-indicator': {
    height: '100%',
    borderRadius: '7px',
    backgroundColor: 'var(--white)',
    boxShadow:
      '0 1px 2px var(--black-alpha-50), 0 0 0 1px var(--black-alpha-50)',
    zIndex: 0
  },
  '& .MuiTabs-flexContainer': { gap: '2px' }
};

export const segmentedSingleTabsSx = {
  width: 'auto',
  minWidth: 0,
  flex: '0 0 auto'
};

export const segmentedTabItemSx = {
  flex: 1,
  maxWidth: '100%',
  minHeight: '36px !important',
  height: '36px !important',
  minWidth: 'unset',
  borderRadius: '7px',
  padding: '0 14px !important',
  fontSize: '13px',
  fontWeight: 500,
  color: 'var(--gray-2)',
  textTransform: 'none',
  flexDirection: 'row',
  gap: '8px',
  zIndex: 1,
  transition: 'color 160ms ease',
  '& .MuiTab-iconWrapper': {
    margin: 0,
    width: '18px',
    height: '18px',
    fontSize: '18px',
    flexShrink: 0
  },
  '&.Mui-selected': {
    color: 'var(--primary)',
    fontWeight: 500
  }
};

export const segmentedSingleTabSx = {
  flex: '0 0 auto',
  maxWidth: 'none'
};

export const segmentedCompactTabSx = {
  flex: '1 1 0% !important',
  minWidth: '0 !important',
  maxWidth: 'none',
  padding: '0 4px !important',
  fontSize: '12px',
  gap: '4px',
  overflow: 'hidden',
  '& .MuiTab-iconWrapper': {
    marginRight: '2px',
    marginBottom: 0,
    width: '16px',
    height: '16px',
    fontSize: '16px',
    flexShrink: 0
  },
  '& .MuiTab-wrapper': {
    minWidth: 0,
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    overflow: 'hidden'
  },
  '& .MuiTab-wrapper > *:last-child': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0
  }
};

export default muiTabsStyles;
